import React from 'react'
import AuthButton from '../../pages/LogInPage/LoginButton'
import { BiArrowBack } from 'react-icons/bi'
import { useNavigate } from 'react-router-dom';
import { closeDialog } from '../../redux/Slices/dialogSlice';
import { useDispatch, useSelector } from 'react-redux';
import { getItem } from '../../utils/token';
import { RootState } from '../../redux/Store/store';
import { StudentDetail } from '../../pages/NewResults/ResultsPage';

const FreeTestsCompleted = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const {parentAssociatedData,selectedStudentId} = useSelector((state : RootState) => ({
        parentAssociatedData : state.root.profileSetupSlice.parentAssociatedData,
        selectedStudentId : state.root.startFullTest.parentStudentId,
    }))

    const handleViewPlans = () =>{
        dispatch(closeDialog())
        navigate('/plans')
    }

    const isParent = getItem('userRole') === 'PARENT'

    const selectedStudent : StudentDetail | undefined = parentAssociatedData && parentAssociatedData?.length > 0 
        ? parentAssociatedData?.find((student: StudentDetail) => student.id === selectedStudentId)
        : undefined;

    return (
        <div className='flex flex-col items-center justify-center gap-9 p-6 pb-9 bg-satPrepFrostedWhite shadow-dialog backdrop-blur-[20px] w-full h-full rounded-[28px]'>
            <div className='flex flex-col gap-3 font-gully'>
            {isParent ? (
                <h2 className="text-[40px] font-bold text-center text-satPrepAccent leading-[120%]">
                  <span className='text-satPrepXDarkAccent'>{`${selectedStudent?.firstName} ${selectedStudent?.lastName}`}</span> has completed all free SAT practice tests!
                </h2>
            ) : (
                <h2 className="text-[40px] font-bold text-center text-satPrepAccent leading-[120%]">
                You’ve reached the limit of your test attempts!
                </h2>
            )}
            <p className='text-lg font-normal text-center text-black px-5'>To continue practicing, please purchase a plan. More tests mean better preparation!</p>
            </div>
            <div className='gap-3 flex'>
                <AuthButton
                text='Purchase Later'
                className='bg-satPrepLightGrey border border-[#828285] !py-[13px] !text-satPrepBlack'
                onClick={() => dispatch(closeDialog())}
                />
                <AuthButton
                text='View Plans'
                icon={<div className='rotate-180'><BiArrowBack size={24} /></div>}
                iconPosition='right'
                className='!px-14'
                onClick={handleViewPlans}
                />
            </div>
        </div>
    )
}

export default FreeTestsCompleted